document.querySelector('.store-details .store-chat-item').addEventListener('click', function() {
    if (window.PodiumWebChat) {
        window.PodiumWebChat.open();
    }
})

document.querySelector('.store-details__info--item .store-email-item').addEventListener('click', function() {
    if (window.outerWidth > 768) {
        const phone = this.getAttribute('data-phone');
        this.textContent = phone;
    }
})
class StoreDistance extends HTMLElement {
    constructor() {
        super();
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    async asynccalcDistanceByCurrentZipcode () {
        // Use Google Maps Geocoding API to get the latitude and longitude of the zipcode
        const zipCode = this.getCookie('mor_zipcode');
        const apiKey = window.MOR_GOOGLE_MAPS_KEY;
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`);
      
        if (response.ok) {
            const data = await response.json();
            
            if (data.status === 'OK' && data.results.length > 0) {
                const location = data.results[0].geometry.location;
                const userLat = location.lat;
                const userLng = location.lng;

                const distance = this.calcGeoDistance(userLat, userLng, this.storeLatitude, this.storeLongitude);
                this.innerText = `${distance} miles away`;
            }
        }
    }

    calcGeoDistance(lat1, lon1, lat2, lon2) {
        const toRad = angle => angle * Math.PI / 180;
        const earthRadius = 3959; // this is mile，km using 6371
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const lat1Rad = toRad(lat1);
        const lat2Rad = toRad(lat2);

        const a = Math.sin(dLat/2) ** 2 +
                Math.cos(lat1Rad) * Math.cos(lat2Rad) *
                Math.sin(dLon/2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return +(earthRadius * c).toFixed(2);
    }

    connectedCallback() {
        this.storeLatitude = parseFloat(this.getAttribute('data-store-latitude'));
        this.storeLongitude = parseFloat(this.getAttribute('data-store-longitude'));

        this.asynccalcDistanceByCurrentZipcode()
    }
}

customElements.define('store-distance', StoreDistance);

function getSanDiegoDate() {
  const now = new Date();
  const options = { 
    timeZone: 'America/Los_Angeles', 
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  };
  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(now);
  const get = type => parts.find(p => p.type === type).value;
  return new Date(
    `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`
  );
}

class StoreTime extends HTMLElement {
    constructor() {
        super();
        this.storeHours = JSON.parse(this.getAttribute('data-json'));
        // this.currentDate = new Date('12/24/2025 11:00:00');
        // this.currentDate = new Date();
        // Convert current time to store's local time (San Diego)
        this.currentDate = getSanDiegoDate();
        this.currentDay = this.currentDate.getDay(); // 0 (Sun) to 6 (Sat)
        this.openStatusTextDom = this.closest('details').querySelector('.store-open-status .status-text');
        this.openStatusTimeDom = this.closest('details').querySelector('.store-open-status .time');
        this.openStatus = {
            status: '',
            hours: ''
        }
        this.renderStoreTime();
    }

    formatTime(timeStr) {
        const [startTime, endTime] = timeStr.split('-');
        if (!startTime || !endTime) return timeStr;

        let [startTimeHour, startTimeMinute] = startTime.trim().split(':');
        let [endTimeHour, endTimeMinute] = endTime.trim().split(':');

        // 08:00 to 8:00
        startTimeHour = Number(startTimeHour) % 12 || 12;
        endTimeHour = Number(endTimeHour) % 12 || 12;

        return `${startTimeHour}:${startTimeMinute} - ${endTimeHour}:${endTimeMinute}`;
    }

    renderStoreTime() {
        const hoursContainer = this.querySelector('.store-hours');
        const holidayContainer = this.querySelector('.holiday-hours');
        const pickupContainer = this.querySelector('.pickup-hours');
        try {
            const hours = JSON.parse(this.dataset.json.replaceAll(/&quot;/g,'"'));

            if (!hours.HolidayHours || hours.HolidayHours.length === 0) {
                holidayContainer.parentElement.style.display = 'none';
            } else {
                for(const day in hours.HolidayHours) {
                    holidayContainer.insertAdjacentHTML('beforeend', `<div>${day}: ${this.formatTime(hours.HolidayHours[day])}</div>`);

                    if (this.openStatus.status) continue;
                    
                    const holidayDate = new Date(day);
                    if (this.currentDate.toDateString() === holidayDate.toDateString()) {
                        const timeRange = hours.HolidayHours[day].split(' - ');
                        if (timeRange[0] === 'CLOSED') {
                            this.openStatus = {
                                status: 'Closed',
                                hours: hours.HolidayHours[day]
                            }
                        } else {
                            const openTime = new Date(holidayDate.toDateString());
                            const closeTime = new Date(holidayDate.toDateString());

                            const [openHour, openMinute, openPeriod] = timeRange[0].match(/(\d+):(\d+)\s(AM|PM)/).slice(1);
                            const [closeHour, closeMinute, closePeriod] = timeRange[1].match(/(\d+):(\d+)\s(AM|PM)/).slice(1);

                            openTime.setHours(openPeriod === 'AM' ? parseInt(openHour) % 12 : (parseInt(openHour) % 12) + 12, parseInt(openMinute), 0);
                            closeTime.setHours(closePeriod === 'AM' ? parseInt(closeHour) % 12 : (parseInt(closeHour) % 12) + 12, parseInt(closeMinute), 0);

                            if (this.currentDate.getTime() >= openTime.getTime() && this.currentDate.getTime() <= closeTime.getTime()) {
                                this.openStatus = {
                                    status: 'Open',
                                    hours: this.formatTime(hours.HolidayHours[day])
                                }
                            } else {
                                this.openStatus = {
                                    status: 'Closed'
                                }
                            }
                        }
                    }
                }
            }

            if (!hours.StoreHours || Object.keys(hours.StoreHours).length === 0) {
                hoursContainer.parentElement.style.display = 'none';
            } else {
                for(const day in hours.StoreHours) {
                    // Monday: 10:00 AM - 08:00 PM
                    // CLOSED
                    hoursContainer.insertAdjacentHTML('beforeend', `<div>${day}: ${this.formatTime(hours.StoreHours[day])}</div>`);
                    if (this.openStatus.status) continue;
                    const dayIndex = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].indexOf(day);
                    if (this.currentDay === dayIndex) {
                        const isClosed = hours.StoreHours[day] === 'CLOSED';
                        if (isClosed) {
                            this.openStatus = {
                                status: 'Closed',
                                hours: hours.StoreHours[day]
                            }
                            continue;
                        }
                        const timeRange = hours.StoreHours[day].split(' - ');
                        const openTime = new Date(this.currentDate);
                        const closeTime = new Date(this.currentDate);

                        const [openHour, openMinute, openPeriod] = timeRange[0].match(/(\d+):(\d+)\s(AM|PM)/).slice(1);
                        const [closeHour, closeMinute, closePeriod] = timeRange[1].match(/(\d+):(\d+)\s(AM|PM)/).slice(1);

                        openTime.setHours(openPeriod === 'AM' ? parseInt(openHour) % 12 : (parseInt(openHour) % 12) + 12, parseInt(openMinute), 0);
                        closeTime.setHours(closePeriod === 'AM' ? parseInt(closeHour) % 12 : (parseInt(closeHour) % 12) + 12, parseInt(closeMinute), 0);

                        if (this.currentDate.getTime() >= openTime.getTime() && this.currentDate.getTime() <= closeTime.getTime()) {
                            this.openStatus = {
                                status: 'Open',
                                hours: this.formatTime(hours.StoreHours[day])
                            }
                        } else {
                            this.openStatus = {
                                status: 'Closed',
                                hours: hours.StoreHours[day]
                            }
                        }
                    }
                }
            }

            if (!hours.PickupHours || Object.keys(hours.PickupHours).length === 0) {
                pickupContainer.parentElement.style.display = 'none';
            } else {
                for(const day in hours.PickupHours) {
                    pickupContainer.insertAdjacentHTML('beforeend', `<div>${day}: ${this.formatTime(hours.PickupHours[day])}</div>`);
                }
            }

            // Render open status
            if (this.openStatus.status === 'Open') {
                this.openStatusTextDom.innerHTML = `Open Now`;
                this.openStatusTimeDom.textContent = this.formatTime(this.openStatus.hours);
            } else {
                this.openStatusTextDom.innerHTML = `Closed Now`;
                this.openStatusTimeDom.textContent = '';
            }

        } catch(e) {
            console.error('Error parsing store hours JSON:', e);
        }
    }
}

customElements.define('store-time', StoreTime);
